const requireExtension = require.context('.', false, /\.js$/)
const registry = []

requireExtension.keys().forEach(fileName => {
  if (fileName === './index.js') return

  const config = requireExtension(fileName).default

  if (config && config.stateKey) {
    registry.push(config)
  }
})

registry.sort((a, b) => a.order - b.order)

export const getExtensions = ({ extensions = [], settings = {} } = {}) => {
  let result = registry

  if (extensions && extensions.length > 0) {
    result = extensions.map(key => registry.find(ext => ext.stateKey === key)).filter(Boolean)
  }

  return result.map(ext => {
    if (ext.native) {
      return ext.stateKey
    }

    const override = settings[ext.stateKey]

    if (override) {
      return {
        ...ext,
        ...override,
        appearance: { ...ext.appearance, ...(override.appearance || {}) },
      }
    }

    return ext
  })
}
